import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-history-saleout',
  templateUrl: './historySaleout.component.html',
  styleUrls: ['./historySaleout.component.css']
})
export class HistorySaleoutComponent implements OnInit {

  page_title = 'LỊCH SỬ GÁN CHIẾN DỊCH SALE-OUT';

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/history-saleout/historySaleout.component.ts